export default "__VITE_ASSET__Cub25lp$__"